'use strict';

module.exports = {
  scriptUrl: 'https://static-ak.pdffiller.com/frontend/SupportChat/503/app.js',
  errorsUrl: 'https://supervisor.pdffiller.com/api/chat/stat',
  socketIo: 'https://support-chat.pdffiller.com/socket.io/socket.io.js'
};